import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageLoader from '../components/PageLoader';
import { DEFAULT_RESEARCH_MARKET_SORT, sortResearchMarkets } from '../lib/researchMarkets';
import { apiJson, isUnauthorizedError } from '../services/api';
import './Research.css';
import './ResearchMarketDetail.css';

export default function ResearchMarketLanding() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function openTopRankedRegion() {
      setError('');
      try {
        const data = await apiJson('/research/markets');
        if (!active) return;

        const rankedMarkets = sortResearchMarkets(
          Array.isArray(data?.markets) ? data.markets : [],
          DEFAULT_RESEARCH_MARKET_SORT,
        );
        const topRankedMarket = rankedMarkets[0];

        if (!topRankedMarket?.region_slug) {
          setError('Could not find a ranked metro market to open.');
          return;
        }

        navigate(`/research/markets/${topRankedMarket.region_slug}`, { replace: true });
      } catch (loadError) {
        if (!active) return;
        if (isUnauthorizedError(loadError)) {
          navigate('/login', { replace: true });
          return;
        }
        setError(loadError?.message || 'Could not load the ranked metro list.');
      }
    }

    void openTopRankedRegion();
    return () => {
      active = false;
    };
  }, [navigate]);

  if (!error) {
    return (
      <div className="research-page">
        <PageLoader label="Opening top-ranked region" />
      </div>
    );
  }

  return (
    <div className="research-page">
      <div className="research-shell">
        <section className="research-detail-hero">
          <div className="research-detail-hero__head">
            <div>
              <Link className="research-detail-back" to="/research">
                <i className="pi pi-arrow-left" />
                Back to Market Research
              </Link>
              <h1 className="research-detail-title">Region Research</h1>
              <p className="research-detail-subtitle">{error}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
